import { render, staticRenderFns } from "./Formular.vue?vue&type=template&id=003615f5&scoped=true&"
import script from "./Formular.vue?vue&type=script&lang=js&"
export * from "./Formular.vue?vue&type=script&lang=js&"
import style0 from "./Formular.vue?vue&type=style&index=0&id=003615f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003615f5",
  null
  
)

export default component.exports